<template>
  <div class="youtaofang">
    <topTitle title="钱湖柏庭" :list="list" :newData="newData"></topTitle>
    <div v-if="!showState">
      <div
        class="item"
        v-for="(item, key) in content"
        :key="key"
        @click="getNewList(item.articleId)"
      >
        <div class="item_left">
          <h1>{{ item.created.substring(5, 7) }}</h1>
          <div class="xian"></div>
          <h3>{{ item.created.substring(8, 10) }}</h3>
        </div>
        <div class="item_right">
          <h1 class="right_top">{{ item.title }}</h1>
          <div class="right_bd">
            <img :src="item.showImage" alt="" />
            <div class="right_content">
              <div class="content_txt" v-html="item.content">
                <!-- {{item.text}} -->
              </div>
              <div class="content_xq" @click="getNewList(item.articleId)">
                阅读详情<i class="el-icon-caret-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page" v-if="!showState">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="getData"
        :current-page.sync="currentPage4"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="10"
        ref="pagination"
        :key="curentIndex"
      ></el-pagination>
    </div>
    <!-- <div class="content_list" v-if="showState" v-html="newList"></div> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          children: [
            {
              title: "2020",
              id: "1",
            },
            {
              title: "2019",
              id: "2",
            },
            {
              title: "2018",
              id: "3",
            },
          ],
        },
      ],
      newData: 3,
      list2: [
        {
          img: require("../../assets/image/fuwu/fang_1.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_2.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_3.png"),
        },
      ],
      curentIndex: 0,
      currentPage4: 1,
      pageNumber: 1,
      getData: 0,
      content: [],
      showState: false,
      newList: "",
      year: "",
    };
  },
  methods: {
    getInfo() {
      if (this.$store.state.pageNumber) {
        this.pageNumber = this.$store.state.pageNumber;
        this.currentPage4 = this.$store.state.pageNumber;
        this.$refs.pagination.internalCurrentPage = this.currentPage4;

        this.curentIndex += 1;
      }
      let pageNumber = this.pageNumber;
      this.year = this.$store.state.year;
      if (this.$route.query.year) {
        this.year = this.$route.query.year;
      }
      console.log(this.year);
      //   this.$store.state.buttonChildren
      axios
        .get(
          "/api/article/paginate?categoryId=3&pageNumber=" +
            pageNumber +
            "&year=" +
            this.year
        )
        .then((res) => {
          this.content = res.data.page.list;
          this.getData = res.data.page.totalRow;
           let height =this.$store.state.scrollTop;
          document.documentElement.scrollTop = height;
        });
    },
    getNewList(e) {
      this.$router.push({
        path: "/Home/homelist",
        query: { majorName: e },
      });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.$store.state.pageNumber = val;
      this.getInfo();
    },
  },
  created: function () {},
  mounted: function () {
    if (this.$route.query.majorName) {
      let e = this.$route.query.majorName;
      this.$router.push({
        path: "/Home/homelist",
        query: { majorName: e },
      });
    }

    this.getInfo();
  },
  components: {
    topTitle,
  },
  props: {},
  watch: {
    "$store.state.buttonChildren": function () {
      //    this.showState= false,
      // this.newList= "",
      this.getInfo();
    },
  },
};
</script>
<style scoped="scoped">
.youtaofang {
  width: 100%;
  height: 100%;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  height: 3.0125rem;
  border-radius: 0.125rem;
}
.item {
  width: 100%;
  height: 3.875rem;
  padding-top: 0.725rem;
  display: flex;
  border-bottom: 1px solid #dcdcdc;
  cursor: pointer;
}
.item:nth-child(11) {
  border-bottom: 0px;
}
.item_left {
  width: 0.875rem;
  display: flex;
  flex-direction: column;
  margin-right: 0.625rem;
}
.item_left h1 {
  height: 0.75rem;
  font-size: 0.75rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #40684b;
  line-height: 0.5375rem;
}
.item_left h3 {
  height: 0.475rem;
  font-size: 0.3875rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #40684b;
  line-height: 43px;
}
.xian {
  width: 100%;
  height: 1px;
  background: #dcdcdc;
}
.item_right {
  width: 11.125rem;
  height: 2.025rem;
}
.right_top {
  font-size: 0.3rem;
  font-family: PingFang SC;
  font-weight: 800;
  color: #222222;
  line-height: 0.5375rem;
  text-align: left;
}
.right_bd {
  margin-top: 0.3125rem;
  height: 2.0125rem;
  display: flex;

  text-align: left;
}
.right_content {
  height: 100%;
  width: 8.125rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right_bd img {
  width: 2.6875rem;
  height: 2.025rem;
  border-radius: 5px;
  margin-right: 0.2875rem;
  object-fit: cover;
}
.content_txt {
  width: 100%;
  height: calc(100% - 0.2125rem - 0.5rem);
  font-size: 0.225rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 0.3125rem;
  overflow: hidden;
}
.content_xq {
  height: 0.2125rem;
  font-size: 0.225rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #40684b;
  line-height: 0.3375rem;
  cursor: pointer;
}
.page {
  margin-top: 1.25rem;
}
</style>